export const skills = [
  {
    'id': 1,
    'heading': 'Frontend development',
    "icon": "https://img.icons8.com/external-photo3ideastudio-flat-photo3ideastudio/64/000000/external-software-developer-online-business-photo3ideastudio-flat-photo3ideastudio.png",
    'text': ` On the Frontend, I specialize in crafting rich user interfaces for web and mobile applications with React, React native and Redux `
  },
  {
    'id': 2,
    'heading': 'Backend development',
    "icon": "https://img.icons8.com/nolan/64/backend-development.png",
    'text': `On the backend I'm experienced in Python/Flask/Django and Express, with a focus on scalability, data-driven design and API development.`
  },
  {
    'id': 3,
    'heading': 'Data Analytics / ML',
    "icon": "https://img.icons8.com/external-flatart-icons-flat-flatarticons/64/000000/external-analysis-statistical-analysis-flatart-icons-flat-flatarticons-3.png",
    'text': `I create data visualizations and machine learning models for unique insights into complex real-time data.`
  },

]


export const techStack = [
  {
    'id': 1,
    'name': "React",
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
  },
  {
    'id': 2,
    "name": 'JavaScript',
    'icon':"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
  },
  {
    'id': 3,
    'name': "Python",
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg"
  },
  {
    'id': 4,
    'name': 'Express',
    'icon':"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg"
  },
  {
    'id': 5,
    'name': "MongoDb",
    'icon':"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg"
  },
  {
    'id': 6,
    'name': "NodeJs",
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg"
  },
  {
    'id': 7,
    'name': "Jest",
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jest/jest-plain.svg"
  },
  {
    'id': 8,
    'name': 'Django',
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg"
  
  },
  {
    'id': 9,
    'name': 'Flask',
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg"
  },
  {
    'id': 10,
    'name': "Tensorflow",
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg"
  },
  {
    'id': 11,
    'name': 'Git',
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg"
  },
  {
    'id': 12,
    'name': "GitHub",
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg"
  },
  {
    'id': 13,
    'name': "Heroku",
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-original.svg"
  },
  {
    'id': 14,
    'name': "Pandas",
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg"
  },
  {
    'id': 15,
    'name': "Numpy",
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/numpy/numpy-original.svg"
  },
  {
    'id': 16,
    'name': 'Html',
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
  },
  {
    'id': 17,
    'name': 'Go',
    'icon': "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/go/go-original-wordmark.svg"
  },

]